export default {
  aldoo_meet: {
    container:
      "w-full flex flex-col",
    item: "bg-paper border hover:border border-bordered hover:border-primary/50 rounded-2xl px-4 md:px-10 py-4 md:py-6 mb-4",
    question:
      "w-full max-w-w2_xl flex justify-between items-center]",
    question_text:
      "text-[18px] md:text-[20px] lg:text-[22px] xl:text-[24px] text-left text-text_secondary font-normal hover:text-primary leading-[24px] md:leading-[28px] lg:leading-[30px] xl:leading-[32px]",
    question_text_selected:
      "text-[18px] md:text-[20px] lg:text-[24px] text-left text-primary font-semibold leading-[24px] md:leading-[28px] lg:leading-[32px]",
    toggle: "text-primary text-[26px] font-light",
    motion_container: "w-full overflow-hidden",
    answer:
      "w-full text-text text-[16px] leading-normal font-normal pr-6 md:pr-10 mt-6 mb-0",
  },

  meet_footer: {
    container: "w-full",
    item: "border-0 border-b border-neutral_3/30 py-1 hover:border-0 hover:border-b hover:border-neutral_3/30",
    question: "flex justify-between items-center w-full text-left focus:outline-none py-3",
    question_text: "footer_group_label text-neutral_1 group-hover:text-neutral_1 text-sm font-semibold tracking-widest uppercase",
    question_text_selected:
      "footer_group_label text-neutral_1 group-hover:text-neutral_1 text-sm font-semibold tracking-widest uppercase",
   
    toggle: "text-neutral_2 group-hover:text-neutral_2",
    motion_container: "overflow-hidden",
    answer: "!text-sm mt-0",
  },
}
